export const simplePluralizeWord = (
  baseWord: string,
  count: number,
  includeCount = true,
): string => {
  const base = includeCount ? `${count} ${baseWord}` : baseWord
  return count === 1 ? base : `${base}s`
}
